
      <ion-toolbar [color]="color" mode="md" [class.scroll-tabs]="scrollTabs">
        <div class="tab-buttons-container" #tabButtonsContainer>
          <div *ngIf="tabsPlacement === 'bottom'" class="indicator {{ 'button-md-' + indicatorColor }}" #indicator></div>
          <div class="tab-buttons" #tabButtons>
            <parent-custom-super-tab-button *ngFor="let tab of tabs; let i = index" (select)="onTabSelect(i)" [title]="tab.title"
                              [icon]="tab.icon" [badge]="tab.badge" [selected]="selectedTab === i" [color]="tabsColor"
                              [badgeColor]="badgeColor"></parent-custom-super-tab-button>
          </div>
          <div *ngIf="tabsPlacement === 'top'" class="indicator {{ 'button-md-' + indicatorColor }}" #indicator></div>
        </div>
      </ion-toolbar>
    